import { navigationActions } from "../reducer";

import { ClientEventHistoryPathFilter } from "../../types";

export const deleteClientEventHistoryFilter = (
  eventFilter: ClientEventHistoryPathFilter
) => navigationActions.deleteClientEventHistoryFilter(eventFilter);
